<app-admin-navbar></app-admin-navbar>
<div class="page">

  <div class="header">

    <h1>
      Categories
    </h1>

    <button
      class="btn-add"
      routerLink="/admin/categories/new">

      Add Category

    </button>

  </div>

        <div
        class="spinner-container"

        *ngIf="loading">

        <div class="spinner">
        </div>

        <p>
            Učitavanje kategorija u toku...
        </p>

        </div>

  <table *ngIf="!loading">

    <thead>

      <tr>

        <th>ID</th>

        <th>Name</th>

        <th>Slug</th>

        <th>Actions</th>

      </tr>

    </thead>

    <tbody>

      <tr
        *ngFor="
          let category
          of categories
        ">

        <td>
          {{ category.id }}
        </td>

        <td>
          {{ category.name }}
        </td>

        <td>
          {{ category.slug }}
        </td>

        <td
          class="actions">

          <button
            class="btn-edit"

            [routerLink]="[
              '/admin/categories/edit',
              category.id
            ]">

            Edit

          </button>

          <button
            class="btn-delete"

            (click)="
              deleteCategory(
                category.id
              )
            ">

            Delete

          </button>

        </td>

      </tr>

    </tbody>

  </table>

</div>